import { Accordion } from '@medly-components/core';
import { InjectClassName } from '@medly-components/utils';
import styled from 'styled-components';

import NavItem from '../NavItem';
import { SubNavListWrapperProps } from './types';

export const SubNavListHeaderIcon = styled.span`
    height: 100%;
`;

export const SubNavListWrapper = styled(InjectClassName)<SubNavListWrapperProps>`
    ${Accordion.Header.Style} {
        display: flex;
        align-items: center;
        background-color: transparent;
        height: ${({ theme }) => theme.sideNav.navItem.minHeight};
        width: ${({ theme }) => `calc(${theme.sideNav.openSize} - ${theme.sideNav.closeSize} + 3.8rem)`};

        ${SubNavListHeaderIcon} {
            svg {
                position: static;
                transform: none;
                transition: none;
                overflow: visible;
                align-self: flex-start;
                font-size: 2.4rem;
                padding: 1.2rem;
            }
        }
    }

    ${Accordion.Content.Style} {
        padding: 0;
        display: ${({ isExpanded, isHovered }) => !isExpanded && !isHovered && 'none'};
        position: relative;
        width: calc(100% - 4.8rem);
        align-self: end;
        &::before {
            position: absolute;
            content: '';
            height: 80%;
            top: 10%;
            left: calc(${({ theme }) => `-${theme.sideNav.closeSize}`} / 3);
            border-left: solid 0.1rem ${({ theme }) => theme.colors.grey[900]};
        }
    }

    ${NavItem.Style} {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        border-radius: 0;
        background-color: transparent;
        max-width: ${({ theme }) => `calc(${theme.sideNav.openSize} - ${theme.sideNav.closeSize} - 2.2rem)`};
        &::before,
        &::after {
            display: none;
        }
    }
`;
